import React, { useEffect } from 'react'
import Aos from 'aos'
import 'aos/dist/aos.css'
import './signature.css'
import { Link} from 'react-router-dom'


// import icons
import {HiOutlineLocationMarker} from 'react-icons/hi'

import img12 from '../../Assets/signImg/img12.jpeg'

const Data = [
    {
        id:12,
        imgSrc: img12,
        destTitle: '浩翰歷史 - 中國名勝古蹟精華瀏覽',
        location: '中國',
        grade: '12-23',
        fees:'3990 美元',
        description:'踏上穿越歷史長河的壯麗旅程，探訪璀璨文化瑰寶：長城的雄偉、故宮的輝煌、祈年殿的莊嚴、雲崗石窟的精湛雕刻、應縣木塔的千年不倒、晉祠的古韻悠長；漫步少林寺與白馬寺，感受佛教文化；走進兵馬俑與三星堆，解讀古代文明；邂逅憨態可掬的大熊貓，流連九寨溝與桂林山水的絕美風光；最後沉浸於蘇州園林的詩意與上海外灘的摩登風情'
      },
  ]

export default function Signature9() {

    useEffect(()=>{
        Aos.init({duration:2000})
    },[])

  return (
<section className='signMain signContainer signSection '>
    <div className='signSecTitle'>
        <h3 data-aos='fade-right' className='signTitle'>
        浩 翰 歷 史 - 中 國 名 勝 古 蹟 精 華 瀏 覽
        </h3>
        <button className='signHomeBtn'><Link to={'/'} className='signHomeBtnLink'>返回首頁</Link></button>
    </div>

    <div className='signSecContent signGrid'>
        { 
            Data.map(({id, imgSrc, destTitle, location, company, fees, description})=>{

                return(
                <div key={id} data-aos='fade-up' className='signSingleDestination'>
                    
                    <div className='signCardInfo'>
                        <h4 className='signDestTitle'>{destTitle}</h4>
                        <span className='signContinent signFlex'>
                        <HiOutlineLocationMarker className='icon' />
                            <span className='signName'>{location}</span>
                        </span>

                        <div className='signFees signFlex'>
                            <div className='signGrade'>
                                <span>
                                {/* 执行机构：{company} */}
                                    <br/>
                                    <small>⭐️ 行 程 精 華 ⭐️</small>
                                    <br/><br/>
                                </span>
                            </div>
                        <div>
                        <br/><p><b>{description}</b></p><br/>
                                
                                <table width='100%'>
                                    <thead>
                                        <tr>
                                            <th width='20%'></th>
                                            <th width='5%'></th>
                                            <th width='75%'></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td><b>長城</b></td>
                                            <td>     </td>
                                            <td>雄偉壯觀的古代軍事防禦工程，綿延萬里，見證中華歷史；</td>  
                                        </tr><br/>
                                        <tr>
                                            <td><b>故宮博物院</b></td>
                                            <td>     </td>
                                            <td>金碧輝煌的皇宮建築群，承載明清兩代的皇家威嚴與文化瑰寶；</td>  
                                        </tr><br/>
                                        <tr>
                                            <td><b>天壇</b></td>
                                            <td>     </td>
                                            <td>明清皇帝祭天祈穀之所，布局嚴謹，體現古代天人合一的哲學思想；</td>  
                                        </tr><br/>
                                        <tr>
                                            <td><b>國家博物館</b></td>
                                            <td>     </td>
                                            <td>匯聚中華五千年文明瑰寶，見證歷史變遷與文化傳承；</td>  
                                        </tr><br/>
                                        <tr>
                                            <td><b>雲崗石窟</b></td>
                                            <td>     </td>
                                            <td>北魏時期的石雕藝術瑰寶，佛像莊嚴，展現古代佛教文化；</td>  
                                        </tr><br/>
                                        <tr>
                                            <td><b>應縣木塔</b></td>
                                            <td>     </td>
                                            <td>世界最高純木結構塔樓，千年不倒，見證古建築技藝之精湛；</td>  
                                        </tr><br/>
                                        <tr>
                                            <td><b>晉祠</b></td>
                                            <td>     </td>
                                            <td>集中國古代園林、廟宇與雕塑藝術於一體，供奉西周名將姬虞；</td>  
                                        </tr><br/>
                                        <tr>
                                            <td><b>河南省博物院</b></td>
                                            <td>     </td>
                                            <td>匯聚中原文化精粹，館藏青銅器、陶俑與歷代文物珍品；</td>  
                                        </tr><br/>
                                        <tr>
                                            <td><b>陝西省博物院</b></td>
                                            <td>     </td>
                                            <td>盛唐氣息濃厚，珍藏大雁塔佛指舍利與漢唐文化遺珍；</td>  
                                        </tr><br/>
                                        <tr>
                                            <td><b>嵩山</b></td>
                                            <td>     </td>
                                            <td>五岳之中，道教與禪宗發源地，峰巒峻峭，歷史底蘊深厚；</td>  
                                        </tr><br/>
                                        <tr>
                                            <td><b>西安城牆</b></td>
                                            <td>     </td>
                                            <td>中國現存最完整的古代城牆，氣勢磅礴，環繞古都西安；</td>  
                                        </tr><br/>
                                        <tr>
                                            <td><b>少林寺</b></td>
                                            <td>     </td>
                                            <td>禪宗祖庭與武術聖地，少林功夫名揚天下，歷史悠久；</td>  
                                        </tr><br/>
                                        <tr>
                                            <td><b>白馬寺</b></td>
                                            <td>     </td>
                                            <td>中國第一座佛教寺院，漢明帝遣使迎佛法之地，古樸典雅；</td>  
                                        </tr><br/>
                                        <tr>
                                            <td><b>龍門石窟</b></td>
                                            <td>     </td>
                                            <td>北魏至唐代的佛教石刻藝術寶庫，萬尊佛像依山而鑿，氣勢恢宏；</td>  
                                        </tr><br/>
                                        <tr>
                                            <td><b>關林</b></td>
                                            <td>     </td>
                                            <td>關羽首級供奉之地，融合廟、墓、林三位一體，象徵忠義精神；</td>  
                                        </tr><br/>
                                        <tr>
                                            <td><b>兵馬俑</b></td>
                                            <td>     </td>
                                            <td>秦始皇陵的地下軍團，千人千面，展現大秦帝國的威嚴與壯麗；</td>  
                                        </tr><br/>
                                        <tr>
                                            <td><b>三星堆</b></td>
                                            <td>     </td>
                                            <td>神秘古蜀文明遺址，青銅面具與黃金權杖揭示未解之謎；</td>  
                                        </tr><br/>
                                        <tr>
                                            <td><b>大熊貓培育基地</b></td>
                                            <td>     </td>
                                            <td>憨態可掬的大熊貓樂園，致力於保護與繁育國寶；</td>  
                                        </tr><br/>
                                        <tr>
                                            <td><b>九寨溝</b></td>
                                            <td>     </td>
                                            <td>如詩如畫的童話世界，五彩湖泊與層疊瀑布令人驚嘆；</td>  
                                        </tr><br/>
                                        <tr>
                                            <td><b>桂林山水</b></td>
                                            <td>     </td>
                                            <td>山青水秀的絕美畫卷，漓江蜿蜒，峰巒倒影如詩如夢；</td>  
                                        </tr><br/>
                                        <tr>
                                            <td><b>銀子岩</b></td>
                                            <td>     </td>
                                            <td>喀斯特地貌的鐘乳石奇觀，石筍銀光閃爍，宛如地下宮殿；</td>  
                                        </tr><br/>
                                        <tr>
                                            <td><b>蘇州園林</b></td>
                                            <td>     </td>
                                            <td>江南園林的巔峰之作，小橋流水、亭台樓閣盡顯古典韻味；</td>  
                                        </tr><br/>
                                        <tr>
                                            <td><b>龍脊梯田</b></td>
                                            <td>     </td>
                                            <td>層層疊疊的梯田如綢帶般盤繞山間，四季變幻，美不勝收；</td>  
                                        </tr><br/>
                                        <tr>
                                            <td><b>上海外灘</b></td>
                                            <td>     </td>
                                            <td>中西合璧的百年建築群，黃浦江畔夜景璀璨，繁華盡顯；</td>  
                                        </tr><br/>


                                    </tbody>
                                </table>
                            </div>
                            

                        </div>

                        <div className='signFees signFlex'>
                            <div className='signGrade'>
                                        <span>
                                            <small>⭐️ 參 團 資 訊 ⭐️</small>
                                        </span>
                                        <br/><br/>
                            </div> <br/>
                            <table width='70%'>
                                    <thead>
                                        <tr>
                                            <th width='15%'></th>
                                            <th width='10%'></th>
                                            <th width='75%'></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>參團年齡</td>
                                            <td>     </td>
                                            <td>14-21歲學生</td>
                                        </tr><br/>
                                        <tr>
                                            <td>適合人群</td>
                                            <td>     </td>
                                            <td>希望玩轉整個中國的古蹟自然景觀的精髓</td>
                                        </tr><br/>
                                        <tr>
                                            <td>時間安排</td>
                                            <td>     </td>
                                            <td>6月-7月「為期24天」</td>
                                        </tr><br/>
                                        <tr>
                                            <td>地 點</td>
                                            <td>     </td>
                                            <td>中國</td>
                                        </tr><br/>
                                        <tr>
                                            <td>费 用 包 括</td>
                                            <td>     </td>
                                            <td>在中國期間的參觀遊覽費用，餐飲費用，住宿費用，交通費用，門票費用；
                                            </td>
                                        </tr><br/>
                                        <tr>
                                            <td>費用不包含</td>
                                            <td>     </td>
                                            <td>
                                                國際旅行手續費、往返國際機票、國際旅行醫療保險、意外保險、個人購物、個人消費。
                                            </td>
                                        </tr><br/>
                                    </tbody>
                            </table>
                        </div>

                    <div className='signFees'>
                        <div className='signGrade'>
                                    <span>
                                        <small>⭐️ 參 考 行 程 ⭐️</small>
                                    </span>
                                    <br/><br/>
                        </div>
                        <br/>
                        <h6>行程範例</h6>
                        <p>實際活動內容可能會有前後調整，或被相近內容替代；夏令營正式開始前四週確定行程細節。</p>
                        <br/>
                        <table width='100%'>
                                        <thead>
                                            <tr>
                                                <th width='20%'>日  期</th>
                                                <th width='40%'>上 午 活 動</th>
                                                <th width='40%'>下 午 活 動</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        <br/>
                                            <tr>
                                                <td>第一日</td>
                                                <td>出發</td>
                                                <td>抵達北京</td>
                                            </tr>
                                            <tr>
                                                <td>第二日</td>
                                                <td>北京故宮</td>
                                                <td>北京故宮</td>
                                            </tr>
                                            <tr>
                                                <td>第三日</td>
                                                <td>北京環球影城</td>
                                                <td>北京環球影城</td>
                                            </tr>
                                            <tr>
                                                <td>第四日</td>
                                                <td>北京天壇</td>
                                                <td>抵達長城</td>
                                            </tr>
                                            <tr>
                                                <td>第五日</td>
                                                <td>北京長城</td>
                                                <td>北京-大同</td>
                                            </tr>
                                            <tr>
                                                <td>第六日</td>
                                                <td>雲岡石窟</td>
                                                <td>應縣木塔</td>
                                            </tr>
                                            <tr>
                                                <td>第七日</td>
                                                <td>晉祠</td>
                                                <td>太原-鄭州</td>
                                            </tr>
                                            <tr>
                                                <td>第八日</td>
                                                <td>河南省博物院</td>
                                                <td>黄河</td>
                                            </tr>
                                            <tr>
                                                <td>第九日</td>
                                                <td>少林寺</td>
                                                <td>嵩山漫步</td>
                                            </tr>
                                            <tr>
                                                <td>第十日</td>
                                                <td>洛陽龍門石窟</td>
                                                <td>白馬寺 / 關林</td>
                                            </tr>
                                            <tr>
                                                <td>第十一日</td>
                                                <td>洛陽 - 西安</td>
                                                <td>西安城牆</td>
                                            </tr>
                                            <tr>
                                                <td>第十二日</td>
                                                <td>兵馬俑</td>
                                                <td>陝西省博物館</td>
                                            </tr>
                                            <tr>
                                                <td>第十三日</td>
                                                <td>西安-成都</td>
                                                <td>西安-成都</td>
                                            </tr>
                                            <tr>
                                                <td>第十四日</td>
                                                <td>三星堆博物館</td>
                                                <td>成都熊貓繁育研究基地</td>
                                            </tr>
                                            <tr>
                                                <td>第十五日</td>
                                                <td>成都 - 桂林</td>
                                                <td>成都 - 桂林</td>
                                            </tr>
                                            <tr>
                                                <td>第十六日</td>
                                                <td>銀子岩</td>
                                                <td>陽朔</td>
                                            </tr>
                                            <tr>
                                                <td>第十七日</td>
                                                <td>阳朔 - 龙脊梯田</td>
                                                <td>龙脊梯田 - 桂林</td>
                                            </tr>
                                            <tr>
                                                <td>第十八日</td>
                                                <td>桂林-上海</td>
                                                <td>桂林-上海</td>
                                            </tr>
                                            <tr>
                                                <td>第十九日</td>
                                                <td>苏州园林</td>
                                                <td>苏州园林</td>
                                            </tr>
                                            <tr>
                                                <td>第二十日</td>
                                                <td>上海豫園</td>
                                                <td>上海外灘</td>
                                            </tr>
                                            <tr>
                                                <td>第二十一日</td>
                                                <td>上海迪斯尼樂園</td>
                                                <td>上海迪斯尼樂園</td>
                                            </tr>
                                            <tr>
                                                <td>第二十二日</td>
                                                <td>返程</td>
                                                <td>抵達甜蜜的家</td>
                                            </tr>
                                        </tbody>
                            </table>

                            <div className='signGrade'>
                        <span>
                            <small>⭐️ 課 程 和 活 動 說 明 ⭐️</small>
                        </span>
                             <br/><br/>
                    </div> 
                            <br/>
                        
                        <h6>每日活動內容包括但不限於（最終的行程，由以下活動的其中一部分組成）：</h6>
                        <p>
                            <b>歷史古蹟: </b>
                                北京故宮；長城；祈年殿；雲岡石窟；應縣木塔；晉祠；少林寺；龍門石窟；白馬寺；關林；蘇州園林；上海豫園
                            <br/>
                            <b>博物展館: </b>
                                中國國家博物館；河南省博物院；陝西省博物院；兵馬俑博物館；三星堆博物館
                            <br/>
                            <b>娛樂: </b>
                                北京環球影城；上海迪斯尼樂園；
                            <br/>
                            <b>社會自然: </b>
                                中岳嵩山；西安城牆；成都大熊貓繁育研究基地；龍脊梯田；陽朔山水；銀子岩溶洞；外灘漫步
                            <br/>
                        </p>
                        {/* // 北京（故宮、長城、祈年殿）；大同（雲岡石窟、應縣木塔）；太原（晉祠）；
                        // 鄭州（省博物院、少林寺、嵩山）；洛陽（龍門石窟，白馬寺，關林）；西安（陝西博物院；兵馬俑，城牆）；
                        // 成都（三星堆博物馆、成都大熊猫繁育研究基地；九寨溝）高鐵-桂林
                        // 桂林（龍脊梯田，陽朔，銀子岩）飛機-上海
                        // 江浙（蘇州園林；上海豫園，外灘） */}
                    </div>
                    
                        <div className='signPrice'>
                            <h5>预 售 价 格 ：{fees}</h5>
                        </div>
                        <Link to={"/formReg"} target="_blank">
                        <button className='signBtn signFees'>
                            <h4>⭐️ ⭐️ ⭐️  預 約 報 名 - 搶 先 卡 位  ⭐️ ⭐️ ⭐️</h4>
                         </button>
                         </Link>
                </div>
                    <div className='signImageDiv'>
                        <img src={imgSrc} alt={destTitle}/>
                    </div>

                </div>
                )
            })
        
        }
       
    </div>

</section>
  )
}
